import { useEffect } from 'react';

interface ClickEvent {
  x: number;
  y: number;
  page: string;
  timestamp: number;
  element?: string;
}

export const HeatmapTracking = () => {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const clickEvent: ClickEvent = {
        x: e.clientX,
        y: e.clientY,
        page: window.location.pathname,
        timestamp: Date.now(),
        element: (e.target as HTMLElement)?.tagName || undefined,
      };

      // Store clicks in localStorage
      const clicks = JSON.parse(localStorage.getItem('heatmap_clicks') || '[]');
      clicks.push(clickEvent);

      // Keep only last 500 clicks
      if (clicks.length > 500) {
        clicks.shift();
      }

      localStorage.setItem('heatmap_clicks', JSON.stringify(clicks));
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  return null;
};

